import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})

export class CheckboxComponent implements ControlValueAccessor {
  @Input() public isErrorExist: boolean;
  @Input() public errorMessage?: string;
  @Input() public isDisabled?: boolean;
  @Input() public isBoldLabel?: boolean;
  @Input() public label?: string;
  @Input() public testId?: string;
  @Input() public inputHint?: string;
  @Input() public hideHint = false;
  // tslint:disable-next-line:variable-name no-input-rename
  @Input('isChecked') _value = false;

  // tslint:disable-next-line:no-output-native
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<boolean>();

  onChange: any = (event) => {
    this.change.emit(event);
  };
  onTouched: any = () => {};

  get isChecked() {
    return this._value;
  }

  set isChecked(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  writeValue(value): void {
    this.isChecked = !!value;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }
}
